import { max } from 'd3';
export function getStrongestPeak(draft) {
    const activeSpectrum = draft.view.spectra.activeSpectra[draft.view.spectra.activeTab];
    if (activeSpectrum) {
        const activeData = draft.data[activeSpectrum?.index].data;
        const strongestPeakValue = max(activeData.re);
        const index = activeData.re.indexOf(strongestPeakValue);
        return {
            xValue: activeData.x[index],
            yValue: strongestPeakValue,
            index,
        };
    }
}
